import React, {Component} from 'react';
import {connect} from 'react-redux';
import {CoreActions, NestActions} from '../../store/actionCreators';
import {Route, Switch} from 'react-router-dom';
import queryString from 'query-string';
import {ApolloProvider} from 'react-apollo';
import {setApolloClient, getApolloClient} from '../../lib/graphQL/apolloClient';
import NestContents from '../../assets/contents/nest';
import NestDevicePage from '../pages/NestDevicePage';
import NestSettingsPage from '../pages/NestSettingsPage';
import LoadingModalContainer from '../nest/containers/LoadingModalContainer';

const DEFAULT_LANGUAGE = 'en';

class NestSubRouter extends Component {
  constructor(props) {
    super(props);

    const {location} = this.props;
    const queryParams = queryString.parse(location.search);

    const awairQueryParams = {
      'deviceUuid': queryParams.deviceUuid,
      'deviceType': queryParams.deviceUuid ? queryParams.deviceUuid.split('_')[0] : '',
      'accessToken': queryParams.accessToken
    };

    // Check lang query parameter existence
    let language = queryParams.lang ? queryParams.lang : DEFAULT_LANGUAGE;

    // Check contents corresponding language
    language = NestContents[language] ? language : DEFAULT_LANGUAGE;

    NestActions.setAwairQueryParams(awairQueryParams);
    CoreActions.setLanguage(language);
  }

  render() {
    const {match, accessToken} = this.props;

    if (!accessToken) {
      return null;
    }

    setApolloClient(accessToken, true);

    return (
      <ApolloProvider client={getApolloClient()}>
        <Switch>
          <Route exact path={`${match.url}`} component={NestDevicePage}/>
          <Route path={`${match.url}/:deviceId`} component={NestSettingsPage}/>
        </Switch>
        <LoadingModalContainer/>
      </ApolloProvider>
    );
  }
}

export default connect(
  ({nest}) => ({
    accessToken: nest.awairQueryParams.accessToken
  }),
  () => ({})
)(NestSubRouter);


// WEBPACK FOOTER //
// ./src/app/routers/NestSubRouter.js